var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 3.83334C6.32501 3.83334 3.33334 6.82501 3.33334 10.5C3.33334 14.175 6.32501 17.1667 10 17.1667C13.675 17.1667 16.6667 14.175 16.6667 10.5C16.6667 6.82501 13.675 3.83334 10 3.83334ZM10.8333 14.6667H9.16668V9.66668H10.8333V14.6667ZM10.8333 8.00001H9.16668V6.33334H10.8333V8.00001Z",
    fill: "#556BF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 6.33332H10.8333V7.99999H9.16666V6.33332ZM9.16666 9.66666H10.8333V14.6667H9.16666V9.66666ZM9.99999 2.16666C5.39999 2.16666 1.66666 5.89999 1.66666 10.5C1.66666 15.1 5.39999 18.8333 9.99999 18.8333C14.6 18.8333 18.3333 15.1 18.3333 10.5C18.3333 5.89999 14.6 2.16666 9.99999 2.16666ZM9.99999 17.1667C6.32499 17.1667 3.33332 14.175 3.33332 10.5C3.33332 6.82499 6.32499 3.83332 9.99999 3.83332C13.675 3.83332 16.6667 6.82499 16.6667 10.5C16.6667 14.175 13.675 17.1667 9.99999 17.1667Z",
    fill: "#556BF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d7cd1322.svg";
export { ForwardRef as ReactComponent };